//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import _ from "lodash";
export default {
  name: "CancelPlanProgressComponent",
  props: {
    array: {
      type: Array,
      default: () => [
        { text: "Feedback", active: true },
        { text: "Detail", active: true },
        { text: "Offer", active: false },
      ],
    },
  },
  data() {
    return {
      diff: 0, // 为了保持居中的相对便宜
    };
  },
  computed: {
    porgressLine() {
      let result = [];
      this.array.forEach((item, index) => {
        // 第一项不做判断
        if (index !== 0) {
          // 判断当前项是否为激活状态，如果是则当前项和前一项之间的连线为实体
          let status = "unactive";
          if (item.active) {
            status = "active";
          }
          result.push({
            id: index,
            status,
          });
        }
      });
      return result;
    },
    circleArr() {
      return this.array.map((item, index) => {
        let status = "unactive";
        if (item.active) {
          // 如果当前处于激活状态则判断当前项是否为最后的激活项
          const lastActiveIndex = _.findLastIndex(this.array, (o) => {
            return o.active;
          });
          console.log("lastActiveIndex", lastActiveIndex);
          // 如果当前为激活的最后一项则为黑色实心圆
          if (lastActiveIndex === index) {
            status = "current";
          } else {
            status = "active";
          }
        }
        return {
          text: item.text,
          status,
        };
      });
    },
  },
  mounted() {
    // 要求不是整个组件居中，而是要求组件进度条那部分居中,也就是要求和下方没字的时候进图条位置一直。所以只能计算属性，相对位置挪一下了
    const firstProgress = this.$refs.progressItems[0].clientWidth;
    const lastProgress =
      this.$refs.progressItems[this.$refs.progressItems.length - 1].clientWidth;
    this.diff = (lastProgress - firstProgress) / 2 + 4;
  },
};



// WEBPACK FOOTER //
// ./src/components/cancel_plan/Progress.vue